module.exports = __webpack_public_path__ + "img/maxbot.a236a07c.png";